<template>
  <div class="container">
    <div class="slider_container">
      <div
        v-for="(box, index) in sliderBoxes"
        :key="index"
        class="slider_box"
        :class="{
          expanded: activeSlider === index,
        }"
        
      >
        <div class="slider_content" @click="toggleSlider(index)">
          <img
            :src="box.icon"
            alt=""
            class="slider_icon"
          />
          <div class="slider_text">
            <p>{{ box.text1 }}</p>
            <p v-if="box.text2">{{ box.text2 }}</p>
          </div>
          <img
            class="down_arrow"
            :class="{ rotated: activeSlider === index }"
            src="../assets/icon/down_arrow.png"
            alt="down_arrow"
          />
        </div>
        <transition name="slide">
          <div
            v-if="activeSlider === index"
            class="carousel"
            @touchstart="handleSwipe"
            @mousedown="handleMouseSwipe"
          >
            <div
              class="carousel_inner"
              :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
            >
              <div
                v-for="(slide, idx) in sliderImages[index]"
                :key="idx"
                class="carousel_item"
              >
                <div class="image_container">
                  <img
                    v-for="(img, i) in slide.images"
                    :key="i"
                    :src="img"
                    alt=""
                    class="carousel_image"
                    :class="{ 'multi-image': slide.images.length > 1 }"
                  />
                </div>
                <div v-if="slide.text" class="slide_text">
                  <p
                    v-for="(line, tIdx) in slide.text"
                    :key="tIdx"
                    :class="
                      line.type === 'main' ? 'slider_mainText' : 'slider_subText'
                    "
                  >
                    {{ line.content }}
                  </p>
                </div>
              </div>
            </div>
            <!-- Pagination Bar -->
            <div class="pagination_container">
              <div
                class="pagination_bar"
                :style="{
                  width: `${100 / sliderImages[index].length}%`,
                  transform: `translateX(${currentSlide * 100}%)`,
                }"
              ></div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="sub_container">
      <div class="image_wrapper">
        <img src="../assets/image/14.jpg" alt="" />
        <div class="overlay">
          <p>DENTRION cuts both</p>
          <p>chair time and stress</p>
          <p>by 50%.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderBoxes: [
        {
          icon: require("../assets/icon/icon_01.svg"),
          text1: "Cutting-Edge QC Systems",
          text2: "",
        },
        {
          icon: require("../assets/icon/icon_02.svg"),
          text1: "ONE-STOP",
          text2: "Digital Manufacturing",
        },
        {
          icon: require("../assets/icon/icon_03.svg"),
          text1: "Nationally Certified",
          text2: "Dental Technicians",
        },
      ],
      sliderImages: [
        [
          { images: [require("../assets/image/slider1_01.svg")] },
          { images: [require("../assets/image/slider1_02.svg")] },
          { images: [require("../assets/image/slider1_03.svg")] },
        ],
        [
          {
            images: [require("../assets/image/slider2_01.svg")],
            text: [
              { content: "CNC", type: "main" },
              { content: "Star Micronics GB", type: "sub" },
            ],
          },
          {
            images: [require("../assets/image/slider2_02.svg")],
            text: [
              { content: "Milling", type: "main" },
              { content: "Machine", type: "main" },
              { content: "Arum 5X-500L", type: "sub" },
              { content: "Ceramill matik", type: "sub" },
            ],
          },
          {
            images: [require("../assets/image/slider2_03.svg")],
            text: [
              { content: "3D Printer", type: "main" },
              { content: "Asiga MAX", type: "sub" },
              { content: "Asiga PRO 4k", type: "sub" },
            ],
          },
        ],
        [
          { images: [require("../assets/image/slider3_01.svg")] },
          { images: [require("../assets/image/slider3_02.svg")] },
          { images: [require("../assets/image/slider3_03.svg")] },
        ],
      ],
      activeSlider: 0,
      currentSlide: 0,
      touchStartX: 0,
      touchStartY: 0,
      touchOffset: 0,
    };
  },
  methods: {
    toggleSlider(index) {
      if (this.activeSlider === index) {
        this.activeSlider = null;
      } else {
        this.activeSlider = index;
        this.currentSlide = 0;
      }
    },
    goToSlide(index) {
      this.currentSlide = index;
      this.touchOffset = 0;
    },
    handleSwipe(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY; 

      const touchMoveHandler = (moveEvent) => {
        const touchMoveX = moveEvent.touches[0].clientX;
        const diffX = touchMoveX - this.touchStartX;
        
        this.touchOffset = diffX;
        const translateX = `translateX(calc(-${this.currentSlide * 100}% + ${
          this.touchOffset
        }px))`;
        document.querySelector(".carousel_inner").style.transform = translateX;
      };

      const touchEndHandler = () => {
        const swipeDistance = this.touchOffset;
        const threshold = 50;
        if (swipeDistance > threshold && this.currentSlide > 0) {
          this.currentSlide--;
        } else if (
          swipeDistance < -threshold &&
          this.currentSlide < this.sliderImages[this.activeSlider].length - 1
        ) {
          this.currentSlide++;
        }
        this.touchOffset = 0;
        document.querySelector(
          ".carousel_inner"
        ).style.transform = `translateX(-${this.currentSlide * 100}%)`;
        document.removeEventListener("touchmove", touchMoveHandler);
        document.removeEventListener("touchend", touchEndHandler);
      };

      document.addEventListener("touchmove", touchMoveHandler);
      document.addEventListener("touchend", touchEndHandler);
    },
    handleMouseSwipe(event) {
      event.preventDefault();
      this.touchStartX = event.clientX;
      this.touchStartY = event.clientY;

      const mouseMoveHandler = (moveEvent) => {
        const diffX = moveEvent.clientX - this.touchStartX;
        this.touchOffset = diffX;
        const translateX = `translateX(calc(-${this.currentSlide * 100}% + ${
          this.touchOffset
        }px))`;
        const carouselInner = document.querySelector(".carousel_inner");
        if (carouselInner) {
          carouselInner.style.transform = translateX;
        }
      };

      const mouseUpHandler = () => {
        const swipeDistance = this.touchOffset;
        const threshold = 50;
        
        if (swipeDistance > threshold && this.currentSlide > 0) {
          this.currentSlide--;
        } else if (
          swipeDistance < -threshold &&
          this.currentSlide < this.sliderImages[this.activeSlider].length - 1
        ) {
          this.currentSlide++;
        }
        
        this.touchOffset = 0;
        
        const carouselInner = document.querySelector(".carousel_inner");
        if (carouselInner) {
          carouselInner.style.transform = `translateX(-${this.currentSlide * 100}%)`;
        }
        
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
        document.removeEventListener("mouseleave", mouseUpHandler); // Handle mouse leaving window
      };

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
      document.addEventListener("mouseleave", mouseUpHandler);
    },
    prevSlide() {
      if (this.currentSlide > 0) this.currentSlide--;
    },
    nextSlide(index) {
      if (this.currentSlide < this.sliderImages[index].length - 1)
        this.currentSlide++;
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 60px 0px;
  gap: 120px;
}

.slider_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 32px;
  width: 100%;
  box-sizing: border-box;
}

.slider_box {
  background-color: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  font-weight: 700;
  color: #0f2e3b;
  cursor: pointer;
  transition: height 0.3s ease;
  width: 100%;
  box-sizing: border-box;
}

.slider_box.expanded {
  background-color: #ffffff;
  color: #0f2e3b;
}

.pagination_container {
  width: 120px;
  margin: 0 auto;
  margin-top: 8px;
  height: 2px;
  background-color: #d9d9d9;
  position: relative;
  border-radius: 2px;
  overflow: hidden;
}

.pagination_bar {
  height: 100%;
  background-color: #3a3a3a;
  transition: transform 0.3s ease;
}

.slider_content {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
}

.slider_icon {
  width: 40px;
}

.down_arrow {
  margin-left: auto;
  width: 12px;
}

.down_arrow.rotated {
  transform: rotate(180deg);
}
.slider_text{
  color: #0B485B;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 128%; /* 25.6px */
  letter-spacing: -1px;
}
.carousel {
  width: 100%;
  position: relative;
  margin-top: 30px;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.carousel_inner {
  display: flex;
  width: 100%;
}

.carousel_item {
  flex: 0 0 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
}

.image_container {
  display: flex;
  width: 100%;
  justify-content: center;
}

.carousel_image {
  height: auto;
  width: 100%;
  object-fit: cover;
  object-position: center;
}



.slide_text {
  position: absolute;
  bottom: 0;
  right: 20px;
  text-align: right;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.slide_text p {
  margin: 0;
}

.slider_mainText {
  color: #121212;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  text-align: right;
  line-height: 128%;
  letter-spacing: -0.8px;
}

.slider_subText {
  color: #121212;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 128%;
  letter-spacing: -0.7px;
}


.pagination {
  display: none;
}

.sub_container {
  position: relative;
  width: 100%;
}

.image_wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.image_wrapper img {
  width: 100%;
  object-fit: cover;
  object-position: center 30%;
  height: 300px;
  display: block;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 900;
  line-height: 1.5;
}

</style>
